import { render, staticRenderFns } from "./AttributeValueListView.vue?vue&type=template&id=1e813dce"
import script from "./AttributeValueListView.vue?vue&type=script&lang=js"
export * from "./AttributeValueListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports